import { render, staticRenderFns } from "./vue-slot-machine.vue?vue&type=template&id=4480b0b6&"
import script from "./vue-slot-machine.vue?vue&type=script&lang=js&"
export * from "./vue-slot-machine.vue?vue&type=script&lang=js&"
import style0 from "./vue-slot-machine.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports